import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../Layouts/Loading";
import { PayRes, useCheckDiscountMutation, useGetPackQuery, usePackageDollarPayMutation, usePackageRialPayMutation } from "../../../Redux/Apis/packageApi";
import qr from '../../../assets/images/qr-code.jpg'
import riali from '../../../assets/images/novinopay.png'
import crypto from '../../../assets/images/crypto.png'
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { fa_currency, fa_number } from "../../../utils/Persian";

type PaymentProps = { id: number|string, close: (v: boolean) => void }

function Payment({id, close}: PaymentProps) {
    const [packageDollarPay, {isLoading: isDollarPayLoading}] = usePackageDollarPayMutation()
    const [packageRialPay, {isLoading: isRialPayLoading}] = usePackageRialPayMutation()
    const [checkDiscount, {isLoading: isDiscountLoading}] = useCheckDiscountMutation()
    const [payType, setPayType] = useState('none')
    const [link,setLink] = useState<PayRes>()
    const [off,setOff] = useState(false)
    const [error,setError] = useState("")
    const {
        data,
        isLoading,
        isSuccess,
    } = useGetPackQuery(+id)

    const [pay, setPay] = useState<any>({
        tracking_code: "",
        discount_code: "",
        price:NaN,
        final_price:NaN,
        package_id:NaN
    })

    useEffect(() => {
      if (data) {
        if (payType === 'rial') {
            setPay({
                tracking_code: "",
                discount_code: "",
                price: data.rial_price,
                final_price: data.rial_sale_price !== null ? data.rial_sale_price : data.rial_price,
                package_id:id
            })
        } else if(payType === 'crypto') {
            setPay({
                tracking_code: "",
                discount_code: "",
                price: data.dollar_price,
                final_price: data.dollar_sale_price !== null ? data.dollar_sale_price : data.dollar_price,
                package_id:id
            })
        }
      }
    }, [id, data, payType])

    const check = async (type: string) => {
        // console.log(type);
        if (pay.discount_code && pay.package_id) {
            let price: number = pay.price;
            const checked = await checkDiscount({code: pay.discount_code, package_id: pay.package_id}).unwrap()
            if (!checked.qualify) {
                const msg = (checked.message || '').toString()
                // Map backend response for referral misuse to a friendly message
                if (msg.includes('DIS_REFERRAL_NOT_ALLOWED'))
                    setError('کد معرف در پرداخت قابل استفاده نیست. لطفا از کد تخفیف معتبر استفاده کنید.')
                else setError(checked.message)
            }
            else {
                let discount_price = 0;
                if (checked.off_percent !== null)
                    discount_price = (pay.price * checked.off_percent) / 100;
                else if (type === 'RIAL' && checked.off_fix_rial !== null) {
                    discount_price = checked.off_fix_rial > price ? price : checked.off_fix_rial;
                } else if (type === 'CRYPTO' && checked.off_fix_dolar !== null) {
                    discount_price = checked.off_fix_dolar > price ? price : checked.off_fix_dolar;
                }
                price = price - discount_price;

                setError(`مبلغ ${discount_price} ${type === 'RIAL' ? "تومان" : "دلار"} از فاکتور شما کسر گردید.`)
                if (price <= 0) setPay((prev:any) => ({ ...prev, 'final_price': 1000 }));
                else setPay((prev:any) => ({ ...prev, 'final_price': price }));
            }
        }

    }

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setPay((prev:any) => ({ ...prev, [name]: value }))
    

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            const payed = await packageDollarPay(pay).unwrap()
            if(payed.status) {
                toast.success('پرداخت شما ثبت گردید و پس از بررسی توسط مدیریت به حسابتان اضافه می گردد.');
                close(false)
            }
            else toast.error(`پرداخت با مشکل روبه رو زیر مواجه گردید!
                ${payed.message}`);
        } catch (err:any){
            console.log(err);
            // const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            // setErrorMsg(message)                                     
        }
    }

    const handlePay = async () => {
        try {
            const link = await packageRialPay(pay).unwrap()
            if (link.url) {
                setLink(link)
                setTimeout(() => { 
                    window.location.href = link.url;
                }, 3000)
            }
            else toast.error(`پرداخت با مشکل روبه رو زیر مواجه گردید!
                ${link.message}`);
            
        } catch (err:any){
            console.log(err);
            toast.success('پرداخت با مشکل روبه رو شد!');
            // const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
        }
    }
    

    return ( 
        <div dir="ltr" className="fixed-top top-50 translate-middle-y border border-secondary-subtle border-5 pt-2 rounded bg-white shadow mx-auto" style={{maxWidth:"80%",overflow:"scroll"}}>
            <div className="row">
            <h6 className="text-center">سفارش پکیج</h6>
            {isLoading && <Loading/>}
            {isSuccess && data &&
            <div className="bg-dark p-4 text-center" style={{minHeight:"70vh",overflow:"scroll"}}>
                <div className="row">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8 col-md-12">
                        <h3 className="text-light mb-3">سفارش <strong className="text-danger">{data.name}</strong></h3>
                        {payType === 'none' && <div className="p-4 bg-light rounded">
                            <h6 className="text-dark" dir="rtl">جهت سفارش <strong className="text-danger">{data.name}</strong> ابتدا یکی از درگاه های ریالی یا تتری را انتخاب نمایید</h6>
                            <hr style={{borderTop: "dashed 2px"}}/>
                            <div className="row">
                                <div role="button" onClick={() => setPayType('crypto')} className="col-6 shadow rounded py-4">
                                    <img src={crypto} alt="crypto" className="img-fluid" width={250}/>
                                    <h6 className="mt-2">(پرداخت تتری)</h6>
                                </div>
                                <div role="button" onClick={() => setPayType('rial')} className="col-6 shadow rounded py-4">
                                    <img src={riali} alt="rial" className="img-fluid" width={250}/>
                                    <h6 className="mt-2">(درگاه ریالی)</h6>
                                </div>
                            </div>
                        </div>}
                        {payType === 'crypto' && <div className="p-4 bg-light rounded">
                            <p className="text-dark" dir="rtl">جهت سفارش <strong className="text-danger">{data.name}</strong> مبلغ <span className="text-decoration-underline">{pay.final_price} تتر(USDT)</span>  را با استفاده از کیف پول خود به آدرس والت زیر انتقال دهید و کد رهگیری انتقال را جهت پیگیری و تایید تراکنش ارسال نمایید</p>
                            <img src={qr} alt="wallet_qrcode" className="img-fluid" width={100}/>
                            <div className="">
                                <button className="btn btn-outline-secondary ms-1" onClick={() => {navigator.clipboard.writeText("TKjJwArdAKXuUVpuGNZT6QDwQCLk9ipPTU"); toast.info('به کلیپبورد اضافه شد.');}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard" viewBox="0 0 16 16">
                                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                    </svg>
                                </button>
                                <strong>TKjJwArdAKXuUVpuGNZT6QDwQCLk9ipPTU</strong>
                            </div> 
                            <p className="p-1 small text-start mt-2" dir="rtl"><FontAwesomeIcon icon="exclamation-triangle" className="me-2 d-inline"/>دقت بفرمایید TRC20 یا Tron را حتما انتخاب نمایید وگرنه پرداختی به GREhub صورت نمی گیرد.</p>
                            <div className="text-start p-2 mb-0 border bg-danger-subtle rounded">
                                <button className="btn btn-default btn-sm" onClick={() => setOff(!off)}>کد تخفیف دارید؟ 
                                <FontAwesomeIcon icon={`chevron-${off ? "down" : "left"}`} className="me-2 align-middle"/></button>
                                {off && 
                                    <div><div className="input-group" dir="rtl">
                                        <input type="text" onChange={handleChange} defaultValue={pay.discount_code} name="discount_code" className="form-control" placeholder="اینجا بنویسید" aria-label="discount code" aria-describedby="button-addon2 basic-addon4"/>
                                        <button className="btn btn-outline-danger" disabled={isDiscountLoading} type="button" id="button-addon2" onClick={() =>  check('CRYPTO')}>ثبت</button>
                                    </div>
                                    {error && <div className="form-text py-2 text-danger" id="basic-addon4" dir="rtl"><FontAwesomeIcon icon="exclamation-circle" className="align-middle mx-1"/><p className="d-inline">{error}</p></div>}
                                    </div>
                                }
                            </div>
                            <hr style={{borderTop: "dashed 2px"}}/>
                            <form id="payForm" onSubmit={onSubmit}>
                                <div className="text-start px-2">
                                    <label htmlFor="pay-input" className="form-label ">کد تراکنش</label>
                                    <input type="text" required dir="rtl" onChange={(e) => setPay((prev: any) => ({...prev, "tracking_code":e.target.value}))} placeholder="کد رهگیری تراکنش" className="form-control bg-secondary-subtle" id="pay-input" aria-describedby="payHelp"/>
                                    <div id="pay-help" className="form-text fw-light"> حتما کد تراکنش خود را وارد نمایید. 
                                        <Link to="/post/40"> (آموزش پرداخت)</Link>
                                    </div>
                                </div>
                            </form>
                        </div>}
                        {payType === 'rial' && <div className="p-4 bg-light rounded">
                            <p className="text-dark" dir="rtl">اطلاعات پکیج انتخابی شما</p>
                            <hr style={{borderTop: "dashed 2px"}}/>
                            <table className="table" dir="rtl">
                                <thead>
                                    <tr>
                                        <th scope="col">نام پکیج</th>
                                        <th scope="col">هزینه پکیج</th>
                                        <th scope="col">هزینه با تخفیف</th>
                                        <th scope="col">نوع پکیج</th>
                                        <th scope="col">مدت/تعداد آزمون</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{data.name}</td>
                                        <td>{fa_currency(+data.rial_price)} تومان</td>
                                        <td>{fa_currency(+pay.final_price)} تومان</td>
                                        <td className={`${data.is_premium ? 'text-danger' : 'text-primary'}`}>{data.is_premium ? 'پرمیوم' : 'اعتباری'}</td>
                                        <td>{data.is_premium ? fa_number(+data.day) + ' روزه' : fa_number(+data.exams) + ' آزمونه'}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="text-start p-2 mb-0 border bg-danger-subtle rounded">
                                <button className="btn btn-default btn-sm" onClick={() => setOff(!off)}>کد تخفیف دارید؟ 
                                <FontAwesomeIcon icon={`chevron-${off ? "down" : "left"}`} className="me-2 align-middle"/></button>
                                {off && 
                                    <div><div className="input-group" dir="rtl">
                                        <input type="text" onChange={handleChange} defaultValue={pay.discount_code} name="discount_code" className="form-control" placeholder="اینجا بنویسید" aria-label="discount code" aria-describedby="button-addon2 basic-addon4"/>
                                        <button className="btn btn-outline-danger" disabled={isDiscountLoading} type="button" id="button-addon2" onClick={() =>  check('RIAL')}>ثبت</button>
                                    </div>
                                    {error && <div className="form-text py-2 text-danger" id="basic-addon4" dir="rtl"><FontAwesomeIcon icon="exclamation-circle" className="align-middle mx-1"/><p className="d-inline">{error}</p></div>}
                                    </div>
                                }
                            </div>
                            <h6 className="p-1 small mt-4" dir="rtl">جهت سفارش <strong className="text-danger">{data.name}</strong> مبلغ <span className="text-decoration-underline">{fa_currency(+pay.final_price)} تومان</span>  را از طریق درگاه پرداخت نمایید.</h6>
                        </div>}
                    </div>
                    <div className="col-lg-2"></div>
                </div>
            </div>}
            <hr />
            </div>
            {payType === 'none' &&  <button type="button" onClick={() => close(false)} className="btn btn-outline-secondary me-4 mb-3 px-5 float-start">انصراف</button>}
            {payType !== 'none' && <button type="button" onClick={() => setPayType('none')} className="btn btn-outline-secondary me-4 mb-3 px-5 float-start">بازگشت<FontAwesomeIcon icon="arrow-right" className="me-1 align-middle"/></button>}
            {payType === 'crypto' && <button type="submit" form="payForm" disabled={isDollarPayLoading}  className="btn btn-success me-4 mb-3 px-5">ثبت سفارش</button>}
            {payType === 'rial' && !link && <button disabled={isRialPayLoading} onClick={handlePay} className="btn btn-success me-4 mb-3 px-5">پرداخت از طریق درگاه</button>}
            {payType === 'rial' && link && <button onClick={() => { if (link?.url) window.location.href = link.url }} type="button" className="btn btn-primary me-4 mb-3 px-5">
                ...هدایت به درگاه
                <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
            </button>}
        </div>
    );
}

export default Payment;
